import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { DataComplaintContext } from "../../Complaints/types";
import { AddComplaintApi } from "../../../redux/complaints/complaintApiCalls";
import InputsComplaintsFront from "./InputsComplaintsFront";
import ButtonElement from "../../../HtmlComponents/ButtonElement";
import SuccessMsg from "../../../Messages/SuccessMsg";
import { Timeout } from "../../../functions/functions";
import ShowErrorMsg from "../../../HtmlComponents/ShowErrorMsg";
import { ShowFrontEndContext } from "../types";
import { useTranslation } from "react-i18next";

const CreateNewComplaint = () => {
  const [fullName, setFullName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [RegNo, setRegNo] = useState<string>("");
  const [cabinetName, setCabinetName] = useState<string>("");
  const [doctorName, setDoctorName] = useState<string>("");
  const [devis, setDevis] = useState<File | any>(null);
  const [message, setMessage] = useState<string>("");
  const [view, setView] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);

  const dispatch: any = useDispatch();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);
  
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("fullName", fullName);
      formData.append("phone", phone);
      formData.append("RegNo", RegNo);
      formData.append("cabinetName", cabinetName);
      formData.append("doctorName", doctorName);
      formData.append("devis", devis);
      formData.append("message", message);
      formData.append("view", JSON.stringify(view));

      const response: any = await dispatch(AddComplaintApi(formData));
      if (response === true) {
        setFullName("");
        setPhone("");
        setRegNo("");
        setCabinetName("");
        setDoctorName("");
        setDevis(null);
        setMessage("");
        setView(false);
        setShowSuccessMsg(true);
        setTimeout(() => setShowSuccessMsg(false), Timeout);
      } else {
        setErrors(response);
      }
    } finally {
      setLoading(false);
    }
  };

  const { ComplaintRef } = useContext(ShowFrontEndContext);
  const { t } = useTranslation()
  return (
    <DataComplaintContext.Provider
      value={{
        fullName,
        setFullName,
        phone,
        setPhone,
        RegNo,
        setRegNo,
        cabinetName,
        setCabinetName,
        doctorName,
        setDoctorName,
        devis,
        setDevis,
        message,
        setMessage,
        view,
        setView,
      }}
    >
      {showSuccessMsg && (
        <SuccessMsg
          modal={showSuccessMsg}
          toggle={() => setShowSuccessMsg(!showSuccessMsg)}
        />
      )}

      <section className="bg-white p-8 rounded-lg shadow-xl max-w-3xl mx-auto" ref={ComplaintRef}>
        {/* Title */}
        <p className="text-main text-center font-semibold text-2xl mb-6 border-b-2 border-main pb-3">
          {t("Déposez votre plainte")}
        </p>

        {/* Error Messages */}
        <ShowErrorMsg errors={errors} setErrors={setErrors} />

        {/* Form */}
        <form className="space-y-6" onSubmit={handleSubmit}>
          {/* Input Fields */}
          <div className="space-y-4">
            <InputsComplaintsFront />
          </div>

          {/* Submit Button */}
          <div className="flex justify-center">
            <ButtonElement type="submit" loading={loading} typeBtn="Ajouter" />
          </div>
        </form>
      </section>
    </DataComplaintContext.Provider>
  );
};

export default CreateNewComplaint;
